<template>
  <div>
    <vxe-grid
      size="small"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.backoutRequestStatus === 'Y'
              ? 'success'
              : row.backoutRequestStatus === 'S'
              ? 'warning'
              : row.backoutRequestStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.backoutRequestStatusText }}
        </el-tag>
        <div v-if="row.rejectReason">
          <el-link
            type="danger"
            :underline="false"
            style="font-size: 13px;"
            @click="showReason(row)"
          >
            {{ $l('btn_showReason') || '查看原因' }}
          </el-link>
        </div>
      </template>
      <template v-slot:displayCustomer="{ row }">
        <div>{{ row.platformName }}</div>
        <div>{{ row.custName }}</div>
      </template>
      <template v-slot:displayWh="{ row }">
        <div>{{ row.whName }}</div>
        <div>{{ row.whAddress }}</div>
      </template>
      <template v-slot:displayApprove="{ row }">
        <div>{{ row.approveByName }}</div>
        <div>{{ row.approveTime }}</div>
      </template>
      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createDate }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { evgBulkOrderCode, evgBulkOrderNo } = data
      switch (menuType) {
        case 'detail':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { evgBulkOrderCode },
            query: { evgBulkOrderNo },
          })
          break
        case 'audit':
          this.audit(data)
          break
        case 'reject':
          this.reject(data)
          break
      }
    },
    async audit({ backoutRequestCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_reviewOrder') || '是否审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomEvgBulkOrderBackoutRequestApproveApi({ backoutRequestCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_audit_failure') || '审核失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_audit_success') || '审核成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    reject({ backoutRequestCode }) {
      this.$prompt(this.$l('tips_reject') || '是否要驳回吗？', '提示', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        inputPlaceholder: this.$l('placeholder_inpute_reason') || '请输入驳回原因',
        inputType: 'textarea',
        inputValidator: (value) => {
          if (value) {
            return true
          }
          return this.$l('validator_message_reason') || '请输入驳回原因'
        },
        inputErrorMessage: this.$l('error_message_reason') || '请输入驳回原因',
      })
        .then(({ value }) => {
          if (this.loadingOpen()) return
          this.$api
            .ecomEvgBulkOrderBackoutRequestRejectApi({
              backoutRequestCode,
              rejectReason: value,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  showClose: true,
                  message: this.$l('tips_review_success') || '驳回成功',
                  type: 'success',
                })
              }
              this.$emit('reload')
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
    showReason({ rejectReason }) {
      this.$alert(rejectReason, this.$l('alert_showReason') || '查看原因', {
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$l('INDEX.btn_cancel') || '关闭',
      })
    },
  },
}
</script>
